function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { X as Close } from "@ignite-analytics/icons";
import { Primary100Shadow } from "../fundations/effects/focusRing";
import { getBackgroundToken, getChipToken, getTextToken } from "../fundations/palette/colorTokens";
import { Corner4, Corner6 } from "../fundations/shape/corners";
export const Chip = {
    MuiChip: {
        defaultProps: {
            size: "medium",
            variant: "default",
            color: "primary",
            skipFocusWhenDisabled: true,
            deleteIcon: /*#__PURE__*/ _jsx(Close, {}),
            iconSize: "medium"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    boxSizing: "border-box",
                    background: getBackgroundToken("backgroundTertiary", theme),
                    color: getTextToken("textPrimary", theme),
                    "& .MuiChip-label": {
                        margin: 0
                    },
                    "& .MuiChip-avatar": {
                        margin: 0
                    },
                    "& .MuiChip-icon": {
                        margin: 0
                    },
                    "& .MuiChip-deleteIcon": {
                        margin: 0,
                        color: getChipToken("dismissDefault", theme),
                        "&:hover": {
                            color: getTextToken("textPrimary", theme)
                        }
                    },
                    "&.Mui-focusVisible": {
                        boxShadow: Primary100Shadow
                    }
                })
        },
        variants: [
            {
                props: {
                    size: "large"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        gap: theme.spacing(0.75),
                        padding: theme.spacing(0.75, 2),
                        borderRadius: Corner6
                    }, theme.typography.textSm), {
                        fontWeight: 500,
                        "& .MuiSvgIcon-root": {
                            fontSize: "16px"
                        },
                        "& .MuiChip-avatar": {
                            width: 24,
                            height: 24
                        },
                        "& .MuiChip-deleteIcon": {
                            width: 16,
                            height: 16
                        },
                        "& .MuiChip-label": {
                            padding: 0
                        }
                    })
            },
            {
                props: {
                    size: "medium"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        gap: theme.spacing(0.75),
                        padding: theme.spacing(0.5, 1.75),
                        borderRadius: Corner6
                    }, theme.typography.textSm), {
                        fontWeight: 500,
                        "& .MuiSvgIcon-root": {
                            fontSize: "16px"
                        },
                        "& .MuiChip-avatar": {
                            width: 24,
                            height: 24
                        },
                        "& .MuiChip-deleteIcon": {
                            width: 16,
                            height: 16
                        },
                        "& .MuiChip-label": {
                            padding: 0
                        }
                    })
            },
            {
                props: {
                    size: "small"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        gap: theme.spacing(0.5),
                        padding: theme.spacing(0.25, 1.5),
                        borderRadius: Corner4
                    }, theme.typography.textSm), {
                        fontWeight: 500,
                        "& .MuiSvgIcon-root": {
                            fontSize: "16px"
                        },
                        "& .MuiChip-avatar": {
                            width: 16,
                            height: 16
                        },
                        "& .MuiChip-deleteIcon": {
                            width: 12,
                            height: 12
                        },
                        "& .MuiChip-label": {
                            padding: 0
                        }
                    })
            },
            {
                props: {
                    size: "xsmall"
                },
                style: ({ theme })=>({
                        gap: theme.spacing(0.5),
                        height: 20,
                        padding: theme.spacing(0.25, 1.25),
                        borderRadius: Corner4,
                        "& .MuiSvgIcon-root": {
                            fontSize: "12px"
                        },
                        "& .MuiChip-avatar": {
                            width: 16,
                            height: 16
                        },
                        "& .MuiChip-deleteIcon": {
                            width: 12,
                            height: 12
                        },
                        "& .MuiChip-label": _object_spread_props(_object_spread({
                            padding: 0
                        }, theme.typography.textXs), {
                            fontWeight: 500
                        })
                    })
            },
            {
                props: {
                    variant: "status"
                },
                style: ()=>({
                        borderRadius: 1337
                    })
            },
            // Conditionally override the icon sizes that as set above. This works because later entries override values set by earlier entries.
            {
                props: {
                    iconSize: "small",
                    size: "xsmall"
                },
                style: ()=>({
                        "& .MuiSvgIcon-root": {
                            fontSize: "6px"
                        }
                    })
            },
            {
                props: {
                    iconSize: "small",
                    size: "small"
                },
                style: ()=>({
                        "& .MuiSvgIcon-root": {
                            fontSize: "8px"
                        }
                    })
            },
            {
                props: {
                    iconSize: "small",
                    size: "medium"
                },
                style: ()=>({
                        "& .MuiSvgIcon-root": {
                            fontSize: "8px"
                        }
                    })
            },
            {
                props: {
                    iconSize: "small",
                    size: "large"
                },
                style: ()=>({
                        "& .MuiSvgIcon-root": {
                            fontSize: "10px"
                        }
                    })
            },
            {
                props: {
                    variant: "link"
                },
                style: ()=>({
                        cursor: "pointer",
                        "& .MuiChip-label": {
                            borderBottomWidth: 1,
                            borderBottomStyle: "solid"
                        }
                    })
            },
            {
                props: {
                    variant: "link",
                    color: "primary"
                },
                style: ({ theme })=>({
                        "& .MuiChip-label": {
                            borderBottomColor: getChipToken("primaryBorder", theme)
                        }
                    })
            },
            {
                props: {
                    variant: "link",
                    color: "neutral"
                },
                style: ({ theme })=>({
                        "& .MuiChip-label": {
                            borderBottomColor: getChipToken("neutralText", theme)
                        }
                    })
            },
            {
                props: {
                    variant: "link",
                    color: "success"
                },
                style: ({ theme })=>({
                        "& .MuiChip-label": {
                            borderBottomColor: getChipToken("successText", theme)
                        }
                    })
            },
            {
                props: {
                    variant: "link",
                    color: "warning"
                },
                style: ({ theme })=>({
                        "& .MuiChip-label": {
                            borderBottomColor: getChipToken("warningText", theme)
                        }
                    })
            },
            {
                props: {
                    variant: "link",
                    color: "error"
                },
                style: ({ theme })=>({
                        "& .MuiChip-label": {
                            borderBottomColor: getChipToken("errorText", theme)
                        }
                    })
            },
            {
                props: {
                    color: "primary"
                },
                style: ({ theme })=>({
                        background: getChipToken("primary", theme),
                        color: getChipToken("primaryText", theme)
                    })
            },
            {
                props: {
                    color: "neutral"
                },
                style: ({ theme })=>({
                        backgroundColor: getChipToken("neutral", theme),
                        color: getChipToken("neutralText", theme)
                    })
            },
            {
                props: {
                    color: "error"
                },
                style: ({ theme })=>({
                        backgroundColor: getChipToken("error", theme),
                        color: getChipToken("errorText", theme)
                    })
            },
            {
                props: {
                    color: "warning"
                },
                style: ({ theme })=>({
                        backgroundColor: getChipToken("warning", theme),
                        color: getChipToken("warningText", theme)
                    })
            },
            {
                props: {
                    color: "success"
                },
                style: ({ theme })=>({
                        backgroundColor: getChipToken("success", theme),
                        color: getChipToken("successText", theme)
                    })
            },
            {
                props: {
                    color: "purple"
                },
                style: ({ theme })=>({
                        background: getChipToken("purple", theme),
                        color: getChipToken("purpleText", theme)
                    })
            },
            {
                props: {
                    variant: "tag"
                },
                style: ({ theme })=>({
                        background: getChipToken("neutral", theme),
                        color: getChipToken("neutralText", theme),
                        "& .MuiChip-icon": {
                            color: getChipToken("dismissDefault", theme)
                        },
                        "& .MuiChip-deleteIcon": {
                            color: getChipToken("dismissDefault", theme)
                        },
                        "&:hover": {
                            color: getTextToken("textInverseB", theme)
                        }
                    })
            }
        ]
    }
};

//# sourceMappingURL=Chip.js.map